











import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IMarkers, IProject } from '@/interfaces/data';
import L from 'leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import store from '@/store';

@Component({
  components: {
    'l-map': LMap,
    'l-marker': LMarker,
    'l-tile-layer': LTileLayer,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  }
})
export default class LeafletMapView extends Vue {
  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];

  private center = L.latLng(-30, 133);
  private zoom = 4;
  private url = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png';

  private created() {
    store.commit('LocationModule/clearAllMarkers');
  }
}
